/**
 *
 * @param light A light theme object
 * @param dark  A dark theme object
 * @returns     A merged theme object with light and dark modes
 * @example
 * const light = {
 *  colors: {
 *   primary: {
 *    100: `#f7fafc`,
 *  }
 * };
 * const dark = {
 * colors: {
 * primary: {
 *    100: `#1a202c`,
 *  }
 * };
 *
 * const mergedTheme = mergeColorMode(light, dark);
 * // { default: `#f7fafc`, _dark: `#1a202c` }
 */
export const mergeColorMode = (light: any, dark: any): any => {
  const merge = (lightNode: any, darkNode: any): any => {
    if (typeof lightNode !== `object` || lightNode === null) {
      return {
        default: lightNode,
        _dark: darkNode,
      };
    }

    return Object.entries(lightNode).reduce(
      (acc, [key, value]) => {
        acc[key] = merge(value, darkNode?.[key]);
        return acc;
      },
      {} as Record<string, any>,
    );
  };

  return merge(light, dark);
};
